module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableSwipeOut),
      expression: "enableSwipeOut"
    }],
    ref: "sidebarWrapper",
    staticClass: "sidebar-wrapper",
    class: _vm.wrapperClass
  }, [_c('div', {
    ref: "sidebarScroller",
    staticClass: "sidebar-scroller",
    style: ({
      'padding-left': _vm.widthProp
    })
  }, [_c('div', {
    staticClass: "sidebar-main",
    style: ({
      width: _vm.widthProp
    }),
    on: {
      "scroll": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    ref: "sidebarToggle",
    staticClass: "touch-toggle",
    style: ({
      'opacity': _vm.opacity,
      'padding-left': _vm.widthProp
    }),
    on: {
      "touchstart": _vm.toggleTouchStart,
      "touchmove": _vm.toggleTouchMove,
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleClick($event)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83387fb0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loaders/theme-loader.js??ref--2-1!./src/components/Sidebar.vue
// module id = 489
// module chunks = 7